import { render, staticRenderFns } from "./ProfitSharingsList/template.html?vue&type=template&id=57774230&scoped=true&"
import script from "./ProfitSharingsList/script.ts?vue&type=script&lang=js&"
export * from "./ProfitSharingsList/script.ts?vue&type=script&lang=js&"
import style0 from "./ProfitSharingsList/style.scss?vue&type=style&index=0&id=57774230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57774230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
